<script setup>
import { h, onBeforeMount, ref } from 'vue';
import { useStore } from '@/store';
import { collectionV2 } from '@/composables/resource';

import SideNav from '../_helpers/layout/SideNav.vue';
import ListingCardHorizontal from '@/components/Secondary/Marketplace/ListingCardHorizontal.vue';

const store = useStore();

const views = [
    {
        key: 'active',
        label: 'Active',
        collection: collectionV2({
            url: '/api/marketplace/listings',
            params: {
                filters: {
                    admin_mode: true,
                    status: 'active',
                    seller_id: store.state.user.id,
                },
            },
        }),
    },
    {
        key: 'draft',
        label: 'Draft',
        collection: collectionV2({
            url: '/api/marketplace/listings',
            params: {
                filters: {
                    admin_mode: true,
                    status: 'draft',
                    seller_id: store.state.user.id,
                },
            },
        }),
    },
    {
        key: 'inReview',
        label: 'In Review',
        collection: collectionV2({
            url: '/api/marketplace/listings',
            params: {
                filters: {
                    admin_mode: true,
                    status: 'pending,rejected',
                    seller_id: store.state.user.id,
                },
            },
        }),
    },
    {
        key: 'sold',
        label: 'Sold',
        collection: collectionV2({
            url: '/api/marketplace/listings',
            params: {
                filters: {
                    admin_mode: true,
                    status: 'sold',
                    seller_id: store.state.user.id,
                },
            },
        }),
    },
];

const dataViewEl = ref();

onBeforeMount(() => {
    //
});
</script>

<template>
    <layout-main>
        <head-title value="My Listings" />
        <SideNav />
        <layout-content>
            <content-header>
                <top-nav>
                    <top-nav-back />

                    <top-nav-title>My Listings</top-nav-title>
                    <div class="grow"></div>
                    <app-collection-query-view-trigger v-if="dataViewEl" :data-view="dataViewEl.dataView" />
                </top-nav>
            </content-header>
            <content-body>
                <div class="p-4">
                    <app-collection-view ref="dataViewEl" :views="views" v-slot="{ activeView }">
                        <ListingCardHorizontal v-for="data in activeView.data" :data="data"></ListingCardHorizontal>
                    </app-collection-view>
                </div>
            </content-body>
        </layout-content>
    </layout-main>
</template>
